/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { ScenarioRequest } from "../../../../gen/subject_spoofer/scenario_request";

export const protobufPackage = "skills";

export interface SpoofSubjectScenarioActionArgs {
  request: ScenarioRequest | undefined;
}

export interface SpoofSubjectScenarioResultData {
}

export interface SpoofSubjectScenarioActionStateData {
}

function createBaseSpoofSubjectScenarioActionArgs(): SpoofSubjectScenarioActionArgs {
  return { request: undefined };
}

export const SpoofSubjectScenarioActionArgs = {
  encode(message: SpoofSubjectScenarioActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.request !== undefined) {
      ScenarioRequest.encode(message.request, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofSubjectScenarioActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofSubjectScenarioActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.request = ScenarioRequest.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpoofSubjectScenarioActionArgs {
    return { request: isSet(object.request) ? ScenarioRequest.fromJSON(object.request) : undefined };
  },

  toJSON(message: SpoofSubjectScenarioActionArgs): unknown {
    const obj: any = {};
    if (message.request !== undefined) {
      obj.request = ScenarioRequest.toJSON(message.request);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofSubjectScenarioActionArgs>, I>>(base?: I): SpoofSubjectScenarioActionArgs {
    return SpoofSubjectScenarioActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofSubjectScenarioActionArgs>, I>>(
    object: I,
  ): SpoofSubjectScenarioActionArgs {
    const message = createBaseSpoofSubjectScenarioActionArgs();
    message.request = (object.request !== undefined && object.request !== null)
      ? ScenarioRequest.fromPartial(object.request)
      : undefined;
    return message;
  },
};

function createBaseSpoofSubjectScenarioResultData(): SpoofSubjectScenarioResultData {
  return {};
}

export const SpoofSubjectScenarioResultData = {
  encode(_: SpoofSubjectScenarioResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofSubjectScenarioResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofSubjectScenarioResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SpoofSubjectScenarioResultData {
    return {};
  },

  toJSON(_: SpoofSubjectScenarioResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofSubjectScenarioResultData>, I>>(base?: I): SpoofSubjectScenarioResultData {
    return SpoofSubjectScenarioResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofSubjectScenarioResultData>, I>>(_: I): SpoofSubjectScenarioResultData {
    const message = createBaseSpoofSubjectScenarioResultData();
    return message;
  },
};

function createBaseSpoofSubjectScenarioActionStateData(): SpoofSubjectScenarioActionStateData {
  return {};
}

export const SpoofSubjectScenarioActionStateData = {
  encode(_: SpoofSubjectScenarioActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofSubjectScenarioActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofSubjectScenarioActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SpoofSubjectScenarioActionStateData {
    return {};
  },

  toJSON(_: SpoofSubjectScenarioActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofSubjectScenarioActionStateData>, I>>(
    base?: I,
  ): SpoofSubjectScenarioActionStateData {
    return SpoofSubjectScenarioActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofSubjectScenarioActionStateData>, I>>(
    _: I,
  ): SpoofSubjectScenarioActionStateData {
    const message = createBaseSpoofSubjectScenarioActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
